export const Product_OS_Data = {
    "square-fascia": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roller Blinds Square Fascia System | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/square-fascia/`,

        Product_OS_TITLE: "Roller Blinds Square Fasica System",
        Product_OS_Label: "Square Fascia",
        // TODO: replace with real product photos — placeholder for now
        Product_OS_Images: [
            "/Assets/SquareFasciaImages/SQUARE-FACIA-01-1.jpg",
            "/Assets/SquareFasciaImages/SQUARE-FACIA-02-1.jpg",
            "/Assets/SquareFasciaImages/SQUARE-FACIA-03-1.jpg",
        ],
        Product_OS_DECRIPTION: "Callistus Square Fascia is an appealing, modern profile that suits a multitude of building designs. The light gauge metal on the front face offers great resistance with a stylish, appearance to ensure a positive performance."
    },
    "top-down-bottom-up": {

        // Page Meta Fields
        META_PG_OG_Title: 'Colby Top-Down Bottom-Up | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/top-down-bottom-up/`,

        Product_OS_TITLE: "Colby Top-Down Bottom-Up",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/-U1mVUFPRPI?si=rDcHTGYTU0J-RylB",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "Callistus Colby Blind Top-Down/Bottom-Up system offers you the ability to operate window blind from the top down or the bottom up to meet all your privacy needs while still giving you access to natural light."
    },
    "colby-blinds-day-and-night": {

        // Page Meta Fields
        META_PG_OG_Title: 'Colby Blinds Day and Night | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//colby-blinds-day-and-night/`,

        Product_OS_TITLE: "Colby Blinds Day and Night",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/-U1mVUFPRPI?si=rDcHTGYTU0J-RylB",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION:
            <>
                Day & Night system offers maximum light control by using two separate fabrics to achieve a day / night level of convenience, providing limitless options for privacy and light control. Day & Night system is available in the following combination options : <br />
                1) Sheer – Translucent <br />
                2) Sheer – Blackout <br />
                3) Translucent – Blackout
            </>
    },
    "colby-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Colby Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//colby-blinds-remote-control/`,

        Product_OS_TITLE: "Colby Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/-U1mVUFPRPI?si=rDcHTGYTU0J-RylB",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colours and can also be affixed to a wall."
    },
    "sierra-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Sierra Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//sierra-blinds-manual/`,

        Product_OS_TITLE: "Sierra Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/lasqvEAXEwI?si=tXrwJ8QJd3yqDBtN",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistuswindow coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "grayson-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Grayson Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//grayson-blinds-manual/`,

        Product_OS_TITLE: "Grayson Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/cufEIlT-VQc?si=pxR7OwBKYhcPMOZV",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "grayson-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Grayson Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//grayson-blinds-remote-control/`,

        Product_OS_TITLE: "Grayson Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/cufEIlT-VQc?si=pxR7OwBKYhcPMOZV",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "roller-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roller Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//roller-blinds-manual/`,

        Product_OS_TITLE: "Roller Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/SdX-ARTzw-c?si=zPkWzp5Xqb--KM1D",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "roller-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roller Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//roller-remote-control/`,

        Product_OS_TITLE: "Roller Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/SdX-ARTzw-c?si=zPkWzp5Xqb--KM1D",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "roller-blinds-one-touch-up": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roller Blinds One Touch Up | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//roller-blinds-one-touch-up/`,

        Product_OS_TITLE: "Roller Blinds One Touch Up",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/SdX-ARTzw-c?si=zPkWzp5Xqb--KM1D",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One Touch Up is a smart system wherein you just need to pull the operating cord, and the blind will roll up on its own."
    },
    "wooden-venetian-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Wooden Venetian Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//wooden-venetian-blinds-manual/`,

        Product_OS_TITLE: "Wooden Venetian Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/EDF9WOHNw08?si=cjyFXgWfhXgQAJev",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "wooden-venetian-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Wooden Venetian Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//wooden-venetian-blinds-remote-control/`,

        Product_OS_TITLE: "Wooden Venetian Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/EDF9WOHNw08?si=cjyFXgWfhXgQAJev",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "TThe Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "wooden-venetian-blinds-smart-phone-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Wooden Venetian Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//wooden-venetian-blinds-remote-control/`,

        Product_OS_TITLE: "Wooden Venetian Blinds Smart Phone Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/EDF9WOHNw08?si=cjyFXgWfhXgQAJev",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "Callistus Automation blinds can be operated using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day."
    },
    "luzon-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Luzon Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//luzon-blinds-manual/`,

        Product_OS_TITLE: "Luzon Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/zDLrxvN5r4w?si=6bl5sckShEFT8_c_",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "luzon-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Luzon Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//luzon-blinds-remote-control/`,

        Product_OS_TITLE: "Luzon Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/zDLrxvN5r4w?si=6bl5sckShEFT8_c_",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "skylight-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Skylight Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//skylight-blinds-remote-control/`,

        Product_OS_TITLE: "Skylight Blinds Remote Control",
        Product_OS_VID_Embed_Link: null,
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate blinds with just a press of a button."
    },
    "panel-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Panel Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//panel-blinds-remote-control/`,

        Product_OS_TITLE: "Panel Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/xRPviMwjlSw?si=O1l4BoC-QuYoGYuS",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate window blinds with just a press of a button."
    },
    "panel-blinds-cord-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Panel Blinds Cord Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//panel-blinds-cord-control/`,

        Product_OS_TITLE: "Panel Blinds Cord Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/xRPviMwjlSw?si=O1l4BoC-QuYoGYuS",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Blinds is their ease of operation. A continuous cord is used to open and close the blinds without any hassles."
    },
    "roman-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roman Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//roman-blinds-manual/`,

        Product_OS_TITLE: "Roman Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/dhpH7ueOQ9o?si=DbO3iAFBL0DdMdbO",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "roman-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roman Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//roman-blinds-remote-control/`,

        Product_OS_TITLE: "Roman Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/dhpH7ueOQ9o?si=DbO3iAFBL0DdMdbO",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to wall."
    },
    "aric-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Aric Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//aric-blinds-manual/`,

        Product_OS_TITLE: "Aric Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/UEKvqzxf6rI?si=BoKKuQU_W_juZJcM",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "patricia-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Patricia Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//patricia-blinds-manual/`,

        Product_OS_TITLE: "Patricia Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/M-90o7MVyug?si=NvDiC8NmiquJRYDJ",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "patricia-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Patricia Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//patricia-blinds-remote-control/`,

        Product_OS_TITLE: "Patricia Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/M-90o7MVyug?si=NvDiC8NmiquJRYDJ",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "dorren-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Dorren Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//dorren-blinds-manual/`,

        Product_OS_TITLE: "Dorren Blinds Manual",
        Product_OS_VID_Embed_Link: null,
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "meliso-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Meliso Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//meliso-blinds-remote-control/`,

        Product_OS_TITLE: "Meliso Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/sQh4OksGmfI?si=HruDSaOeva2d0Ji9   ",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "eton-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Eton Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}//eton-blinds-manual/`,

        Product_OS_TITLE: "Eton Blinds Manual",
        Product_OS_VID_Embed_Link: null,
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
}